import React, { useState, useEffect } from "react";
import { CloseOutlined } from "@ant-design/icons";
import styles from "../styles/QurealRichEditor.module.css";

const YoutubeModal = ({
    isOpen,
    onClose,
    onConfirm,
    initialWidth = 640,
    initialHeight = 360,
}) => {
    const [url, setUrl] = useState("");
    const [width, setWidth] = useState(initialWidth);
    const [height, setHeight] = useState(initialHeight);

    useEffect(() => {
        if (isOpen) {
            setUrl("");
            setWidth(initialWidth);
            setHeight(initialHeight);
        }
    }, [isOpen, initialWidth, initialHeight]);

    if (!isOpen) return null;

    return (
        <div className={styles.linkModalOverlay}>
            <div className={`${styles.linkModal} ${styles.youtubeModal}`}>
                <div className={styles.linkModalHeader}>
                    <h3>Insert YouTube Video</h3>
                    <button onClick={onClose} className={styles.linkModalClose}>
                        <CloseOutlined />
                    </button>
                </div>
                <div className={styles.linkModalBody}>
                    <label htmlFor="youtube-url">YouTube URL</label>
                    <input
                        id="youtube-url"
                        type="text"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        className={styles.linkInput}
                        placeholder="https://www.youtube.com/watch?v=..."
                        autoFocus
                    />

                    <div className={styles.youtubeDimensions}>
                        <div className={styles.dimensionInput}>
                            <label htmlFor="width">Width</label>
                            <input
                                id="width"
                                type="number"
                                value={width}
                                onChange={(e) => setWidth(e.target.value)}
                                className={styles.linkInput}
                            />
                        </div>
                        <div className={styles.dimensionInput}>
                            <label htmlFor="height">Height</label>
                            <input
                                id="height"
                                type="number"
                                value={height}
                                onChange={(e) => setHeight(e.target.value)}
                                className={styles.linkInput}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.linkModalFooter}>
                    <button
                        onClick={onClose}
                        className={`${styles.linkModalButton} ${styles.cancelButton}`}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onConfirm(url, width, height)}
                        className={`${styles.linkModalButton} ${styles.confirmButton}`}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default YoutubeModal;
